import React, { useState } from 'react';
import { Tag, ChevronDown, ChevronUp } from 'lucide-react';

const ConceptsTab = ({ documentData, analysisResults }) => {
  const [expandedConcepts, setExpandedConcepts] = useState({});
  
  // Récupérer les concepts et leurs descriptions
  const concepts = analysisResults?.concepts || [];
  const conceptDescriptions = analysisResults?.conceptDescriptions || [];
  
  // Log pour confirmer la structure
  console.log("[ConceptsTab] Descriptions de concepts:", conceptDescriptions);
  
  const toggleConcept = (concept) => {
    setExpandedConcepts(prev => ({
      ...prev,
      [concept]: !prev[concept]
    }));
  };
  
  // Si aucun concept n'est disponible
  if (concepts.length === 0) {
    return (
      <div className="text-center py-10">
        <Tag className="h-12 w-12 text-gray-300 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-700 mb-2">Aucun concept clé identifié</h3>
        <p className="text-gray-500">
          L'analyse n'a pas identifié de concepts clés dans ce document.
        </p>
      </div>
    );
  }
  
  return (
    <div className="space-y-5">
      <div className="flex justify-between items-center">
        <h2 className="text-lg font-medium text-gray-900">
          Concepts clés du document
        </h2>
        <span className="text-sm text-gray-500">
          {concepts.length} concept{concepts.length > 1 ? 's' : ''} identifié{concepts.length > 1 ? 's' : ''}
        </span>
      </div>
      
      <div className="space-y-4">
        {concepts.map((concept, index) => {
          // Rechercher la description détaillée du concept
          const conceptName = typeof concept === 'object' ? concept.title : concept;
          const description = conceptDescriptions.find(desc => desc.concept === conceptName);
          const isExpanded = !!expandedConcepts[conceptName];
          
          return (
            <div 
              key={index} 
              className="border border-gray-200 rounded-lg overflow-hidden bg-white transition-shadow hover:shadow-sm"
            >
              <div 
                className="p-4 flex justify-between items-center cursor-pointer"
                onClick={() => toggleConcept(conceptName)}
              >
                <div className="flex items-center gap-3">
                  <Tag className="h-5 w-5 text-blue-500" />
                  <h3 className="font-medium text-gray-800">{conceptName}</h3>
                </div>
                <button className="p-1 text-gray-400 hover:text-gray-600">
                  {isExpanded ? <ChevronUp className="h-5 w-5" /> : <ChevronDown className="h-5 w-5" />}
                </button>
              </div>
              
              {isExpanded && description && (
                <div className="px-4 pb-4 border-t border-gray-100 pt-3">
                  {description.description ? (
                    <div>
                      <p className="text-sm text-gray-600">{description.description}</p>
                    </div>
                  ) : (
                    <p className="text-sm text-gray-600">Aucune description disponible pour ce concept.</p>
                  )}
                  
                  {description.relatedConcepts && description.relatedConcepts.length > 0 && (
                    <div className="mt-3">
                      <h4 className="text-sm font-medium text-gray-700 mb-1">Concepts liés</h4>
                      <div className="flex flex-wrap gap-1 mt-1">
                        {description.relatedConcepts.map((relatedConcept, idx) => (
                          <span 
                            key={idx} 
                            className="px-2 py-0.5 bg-blue-50 text-blue-600 rounded-full text-xs"
                          >
                            {relatedConcept}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
      
      <div className="text-center py-4">
        <p className="text-sm text-gray-500">
          Les concepts clés sont extraits automatiquement du contenu du document.
        </p>
      </div>
    </div>
  );
};

export default ConceptsTab;